import React from 'react'
import { ReactFlowProvider } from '@xyflow/react'
import SurveyCanvas from './canvas/SurveyCanvas'

/**
 * Memoized inner component — only re-renders when initList reference changes.
 * Prevents ReactFlow's internal StoreUpdater from entering an infinite loop
 * caused by parent re-renders triggering ReactFlowProvider context resets.
 */
const StableCanvas = React.memo(({ initList, canvasRef }) => {
    return (
        <SurveyCanvas
            ref={canvasRef}
            initList={initList}
        />
    )
})

StableCanvas.displayName = 'StableCanvas'

/**
 * SurveyBuilder — wraps SurveyCanvas in ReactFlowProvider.
 * Provider is at the top so it stays mounted across parent re-renders.
 */
export default function SurveyBuilder({ initList, canvasRef }) {
    return (
        <ReactFlowProvider>
            <StableCanvas initList={initList} canvasRef={canvasRef} />
        </ReactFlowProvider>
    )
}
